import { Image } from "@nextui-org/react";
import { IProductVariant } from "@/interfaces/product";
import { useEffect, useState } from "react";
import { isEqual } from "lodash";
import SkeletonElement from "@/components/Shares/SkeletonElement";
// import {
//   Modal,
//   ModalContent,
//   ModalBody,
//   useDisclosure,
// } from "@nextui-org/react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import VideoPlayer from "@/components/Shares/VideoPlayer";
import { FaRegPlayCircle } from "react-icons/fa";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";

interface ProductGalleryProps {
  productVariants: IProductVariant[];
  selectedVariant: IProductVariant;
}

const ProductGallery: React.FC<ProductGalleryProps> = ({
  productVariants,
  selectedVariant,
}) => {
  // const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    if (selectedVariant?.images?.length) {
      setSelectedImage(selectedVariant.images[0]);
    }
  }, [selectedVariant]);

  const getAllMediaItems = () => {
    return productVariants.flatMap((variant) => [
      ...variant.images,
      ...(variant.videosUrl ?? []).map((url) => `video:${url}`),
    ]);
  };

  const handleNextImage = () => {
    const allMedia = getAllMediaItems();
    const currentIndex = allMedia.indexOf(selectedImage);
    const nextIndex = (currentIndex + 1) % allMedia.length;
    setSelectedImage(allMedia[nextIndex]);
  };

  const handlePrevImage = () => {
    const allMedia = getAllMediaItems();
    const currentIndex = allMedia.indexOf(selectedImage);
    const prevIndex = (currentIndex - 1 + allMedia.length) % allMedia.length;
    setSelectedImage(allMedia[prevIndex]);
  };

  const isVideo = selectedImage.startsWith("video:");
  const videoUrl = isVideo ? selectedImage.replace("video:", "") : "";

  return (
    <>
      <section className="flex flex-col lg:flex-row gap-6 select-none">
        <div className="relative max-h-[70vh] hidden lg:block">
          <PerfectScrollbar className="flex flex-col gap-1 w-24">
            {productVariants.map((variant) => {
              const extendedImages = [
                ...(variant.videosUrl ?? []).map((url) => `video:${url}`),
                ...variant.images,
              ];

              return extendedImages.map((img) => {
                const isVid = img.startsWith("video:");
                const thumb = variant.images[0] || "/fallback-video-thumb.jpg";
                return (
                  <div
                    key={img}
                    className={`relative size-16 flex-shrink-0 cursor-pointer overflow-hidden flex items-center justify-center border transition-all duration-500 ${
                      isEqual(img, selectedImage)
                        ? "border-icon shadow-card"
                        : "border-stroke"
                    }`}
                    onClick={() => setSelectedImage(img)}
                  >
                    <Image
                      radius="none"
                      alt="thumb"
                      src={isVid ? thumb : img}
                      className="w-full h-full object-cover"
                    />
                    {isVid && (
                      <div className="absolute inset-0 flex items-center justify-center z-10">
                        <FaRegPlayCircle className="text-white text-xl drop-shadow" />
                      </div>
                    )}
                  </div>
                );
              });
            })}
          </PerfectScrollbar>
        </div>

        <div className="relative flex justify-center items-center w-full overflow-hidden cursor-pointer">
          {selectedVariant.oldPrice !== 0 && (
            <div className="absolute z-10 size-16 right-0 top-0">
              <Image src="/sale-icon.png" alt="sales icon" />
            </div>
          )}
          <div
            id="prev"
            className="absolute z-10 top-1/2 left-3 size-10 rounded-full bg-gray-100 flex items-center justify-center"
            onClick={handlePrevImage}
          >
            <IoIosArrowBack className="text-lg text-icon" />
          </div>

          {!isVideo ? (
            <AnimatePresence mode="wait">
              {selectedImage && (
                <motion.div
                  key={selectedImage}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.3 }}
                  className="max-h-full max-w-full"
                >
                  <InnerImageZoom
                    src={selectedImage}
                    zoomSrc={selectedImage}
                    zoomType="click"
                    zoomPreload={true}
                    className="object-contain"
                  />
                </motion.div>
              )}
            </AnimatePresence>
          ) : (
            // <AnimatePresence mode="wait">
            //   <motion.img
            //     key={selectedImage}
            //     src={selectedImage}
            //     alt="preview"
            //     className="max-h-full max-w-full object-contain"
            //     initial={{ opacity: 0, scale: 0.9 }}
            //     animate={{ opacity: 1, scale: 1 }}
            //     exit={{ opacity: 0, scale: 0.9 }}
            //     transition={{ duration: 0.3 }}
            //     onClick={onOpen}
            //   />
            // </AnimatePresence>
            <VideoPlayer src={videoUrl} />
          )}

          <div
            id="next"
            className="absolute z-10 top-1/2 right-3 size-10 rounded-full bg-gray-100 flex items-center justify-center"
            onClick={handleNextImage}
          >
            <IoIosArrowForward className="text-lg text-icon" />
          </div>
        </div>

        {/* <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        size="full"
        className="w-[90vw] h-[90vh] max-w-[1800px] max-h-[1500px]"
      >
        <ModalContent className="select-none">
          <ModalBody>
            <div className="flex justify-between p-8">
              <div className="w-full lg:w-2/3 p-8 flex items-center justify-center">
                {!isVideo ? (
                  <Image src={selectedImage} alt="preview" radius="none" />
                ) : (
                  <VideoPlayer src={videoUrl} />
                )}
              </div>
              <div className="w-1/4 hidden lg:block">
                <h2 className="text-lg mb-4">{selectedVariant.name}</h2>
                <div className="flex gap-4 flex-wrap">
                  {[
                    ...selectedVariant.images,
                    ...(selectedVariant.videosUrl ?? []).map(
                      (v) => `video:${v}`
                    ),
                  ].map((img) => {
                    const isVid = img.startsWith("video:");
                    const thumb =
                      selectedVariant.images[0] || "/fallback-video-thumb.jpg";
                    return (
                      <div
                        key={img}
                        className={`relative size-16 cursor-pointer overflow-hidden flex items-center justify-center border transition-all duration-500 ${
                          isEqual(img, selectedImage)
                            ? "border-icon shadow-card"
                            : "border-stroke"
                        }`}
                        onClick={() => setSelectedImage(img)}
                      >
                        <Image
                          radius="none"
                          alt="thumb"
                          src={isVid ? thumb : img}
                          className="w-full h-full object-cover"
                        />
                        {isVid && (
                          <div className="absolute inset-0 flex items-center justify-center z-10">
                            <FaRegPlayCircle className="text-white text-xl drop-shadow" />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal> */}
      </section>
    </>
  );
};

export const ProductGallerySkeleton = () => (
  <section className="flex gap-6">
    <div className="flex flex-col gap-1 ">
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          className="size-16 overflow-hidden flex items-center justify-center border "
        >
          <SkeletonElement />
        </div>
      ))}
    </div>
    <div className="flex justify-center h-[500px] w-full overflow-hidden">
      <SkeletonElement />
    </div>
  </section>
);

export default ProductGallery;
